var videoLibrary={};
var categoryIndex=0;
videoLibrary.categories={};
videoLibrary.categories.title='<span>Did you know proper application ?</span> <h2>Can Boost Results?</h2>';
videoLibrary.categories.data=[];

// Category 1
//Category page related data
videoLibrary.categories.data[categoryIndex]={};
videoLibrary.categories.data[categoryIndex].title="CLEANSERS & TONERS";
videoLibrary.categories.data[categoryIndex].coverImage="https://cdn.shopify.com/s/files/1/1234/0846/files/CLEANSERS_TONERS_Category_Cover.png?v=1663743711";
videoLibrary.categories.data[categoryIndex].description="Our cleansing and toning formulas, cleanse the skin without upsetting the natural pH or moisture balance.";

//Video 1
videoLibrary.categories.data[categoryIndex]["videos"]=[];
videoLibrary.categories.data[categoryIndex]["videos"][0]={};
videoLibrary.categories.data[categoryIndex]["videos"][0].title="<span>Learn About</span><h2>Cleansing</h2>";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoUrl="https://cdn.shopify.com/videos/c/o/v/c8fc9eb260d148e2a9817c5dc5301530.mp4";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoPoster="https://cdn.shopify.com/s/files/1/1234/0846/files/Cleansing_Mousse_Thumbnail.png?v=1664430830";
videoLibrary.categories.data[categoryIndex]["videos"][0].products=[];
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/products/marine-purifying-cleansing-mousse');

//video 2
videoLibrary.categories.data[categoryIndex]["videos"][1]={};
videoLibrary.categories.data[categoryIndex]["videos"][1].title="<span>Learn About</span><h2>Toning</h2>";
videoLibrary.categories.data[categoryIndex]["videos"][1].videoUrl="https://cdn.shopify.com/videos/c/o/v/3b33e1ab1f3143c79da64f9f30baa4fe.mp4";
videoLibrary.categories.data[categoryIndex]["videos"][1].videoPoster="https://cdn.shopify.com/s/files/1/1234/0846/files/Toners_Thumbnail.png?v=1667391420";
videoLibrary.categories.data[categoryIndex]["videos"][1].products=[];
videoLibrary.categories.data[categoryIndex]["videos"][1].products.push('/products/balancing-collagen-tonic');
videoLibrary.categories.data[categoryIndex]["videos"][1].products.push('/products/calming-collagen-tonic');
videoLibrary.categories.data[categoryIndex]["videos"][1].products.push('/products/revitalizing-collagen-tonic');

// Category 2
//Category page related data
categoryIndex++;
videoLibrary.categories.data[categoryIndex]={};
videoLibrary.categories.data[categoryIndex].title="ELIXIRS & SERUMS";
videoLibrary.categories.data[categoryIndex].coverImage="https://cdn.shopify.com/s/files/1/1234/0846/files/elisar_img.png?v=1667392447";
videoLibrary.categories.data[categoryIndex].description="Learn about Haute’s Crown Jewel Treatments with Elixirs and Serums.";

//Video 1
videoLibrary.categories.data[categoryIndex]["videos"]=[];
videoLibrary.categories.data[categoryIndex]["videos"][0]={};
videoLibrary.categories.data[categoryIndex]["videos"][0].title="<span>Learn About</span><h2>Elixirs and Serums</h2>";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoUrl="https://cdn.shopify.com/videos/c/o/v/89d80e64aee9444387831fbd0b2930d2.mp4";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoPoster="https://cdn.shopify.com/s/files/1/1234/0846/files/Serum_vs_Elixir_Thumbnail.png?v=1667392823";
videoLibrary.categories.data[categoryIndex]["videos"][0].products=[];
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/collections/md-personalized');
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/collections/elixir-treatments');

// Category 3
//Category page related data
categoryIndex++;
videoLibrary.categories.data[categoryIndex]={};
videoLibrary.categories.data[categoryIndex].title="EYES & LIPS";
videoLibrary.categories.data[categoryIndex].coverImage="https://cdn.shopify.com/s/files/1/1234/0846/files/EYES_LIPS_Category_Cover.png?v=1663742405";
videoLibrary.categories.data[categoryIndex].description="Our co-founder Diego, show you how to provide hydration, strength and restore to these areas.";

//Video 1
videoLibrary.categories.data[categoryIndex]["videos"]=[];
videoLibrary.categories.data[categoryIndex]["videos"][0]={};
videoLibrary.categories.data[categoryIndex]["videos"][0].title="<span>Learn About</span><h2>Eye Restore</h2>";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoUrl="https://cdn.shopify.com/videos/c/o/v/e26ef2a4be8b4c86bd983d62c5739669.mp4";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoPoster="https://cdn.shopify.com/s/files/1/1234/0846/files/eye-restore.png?v=1667393618";
videoLibrary.categories.data[categoryIndex]["videos"][0].products=[];
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/products/upperlidandcontoursublimeeyebalm');
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/products/eye-brighten-br-illuminate-lift-br-eye-serum-concentrate');
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/products/eye-support-br-quench-restore-br-eye-serum-concentrate');

//video 2
videoLibrary.categories.data[categoryIndex]["videos"][1]={};
videoLibrary.categories.data[categoryIndex]["videos"][1].title="<span>Learn About</span><h2>Eye Restore</h2>";
videoLibrary.categories.data[categoryIndex]["videos"][1].videoUrl="https://cdn.shopify.com/videos/c/o/v/dadadaa4a9b24676a10f24f6fd6cb183.mp4";
videoLibrary.categories.data[categoryIndex]["videos"][1].videoPoster="https://cdn.shopify.com/s/files/1/1234/0846/files/eye_sev2.png?v=1667546667";
videoLibrary.categories.data[categoryIndex]["videos"][1].products=[];
videoLibrary.categories.data[categoryIndex]["videos"][1].products.push('/products/upperlidandcontoursublimeeyebalm');
videoLibrary.categories.data[categoryIndex]["videos"][1].products.push('/products/eye-brighten-br-illuminate-lift-br-eye-serum-concentrate');
videoLibrary.categories.data[categoryIndex]["videos"][1].products.push('/products/eye-support-br-quench-restore-br-eye-serum-concentrate');

//video 3
videoLibrary.categories.data[categoryIndex]["videos"][2]={};
videoLibrary.categories.data[categoryIndex]["videos"][2].title="<span>Learn About</span><h2>Lip Nurturing</h2>";
videoLibrary.categories.data[categoryIndex]["videos"][2].videoUrl="https://cdn.shopify.com/videos/c/o/v/dadadaa4a9b24676a10f24f6fd6cb183.mp4";
videoLibrary.categories.data[categoryIndex]["videos"][2].videoPoster="https://cdn.shopify.com/s/files/1/1234/0846/files/Full_Lips_Serum_Thumbnail.png?v=1664430830";
videoLibrary.categories.data[categoryIndex]["videos"][2].products=[];
videoLibrary.categories.data[categoryIndex]["videos"][2].products.push('/products/full-lips-plump-smooth-contour-lip-serum-concentrate');

// Category 4
//Category page related data
categoryIndex++;
videoLibrary.categories.data[categoryIndex]={};
videoLibrary.categories.data[categoryIndex].title="MOISTURIZERS & SUN";
videoLibrary.categories.data[categoryIndex].coverImage="https://cdn.shopify.com/s/files/1/1234/0846/files/MOISTURIZERS_SUN_Category_Cover.png?v=1663743715";
videoLibrary.categories.data[categoryIndex].description="Diego's Moisture Pro Tips, achieve truly healthy skin and a fresh, natural complexion.";

//Video 1
videoLibrary.categories.data[categoryIndex]["videos"]=[];
videoLibrary.categories.data[categoryIndex]["videos"][0]={};
videoLibrary.categories.data[categoryIndex]["videos"][0].title="<span>Learn About</span><h2>Moisturizing</h2>";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoUrl="https://cdn.shopify.com/videos/c/o/v/44ef751fe5da414ba9587218707ef578.mp4";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoPoster="https://cdn.shopify.com/s/files/1/1234/0846/files/2_Types_of_Moisturizer_Thumbnail.png?v=1664430830";
videoLibrary.categories.data[categoryIndex]["videos"][0].products=[];
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/products/creme-supreme');
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/products/emulsion-supreme');
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/products/fluid-supreme');

//video 2
videoLibrary.categories.data[categoryIndex]["videos"][1]={};
videoLibrary.categories.data[categoryIndex]["videos"][1].title="<span>Learn About</span><h2>SPF Reapplication</h2>";
videoLibrary.categories.data[categoryIndex]["videos"][1].videoUrl="https://cdn.shopify.com/videos/c/o/v/194fca63316148e281c5e7a72a109c06.mp4";
videoLibrary.categories.data[categoryIndex]["videos"][1].videoPoster="https://cdn.shopify.com/s/files/1/1234/0846/files/SPF_Reapplication.png?v=1667551563";
videoLibrary.categories.data[categoryIndex]["videos"][1].products=[];
videoLibrary.categories.data[categoryIndex]["videos"][1].products.push('/products/radiance-superbe-day-cream');

// Category 5
//Category page related data
categoryIndex++;
videoLibrary.categories.data[categoryIndex]={};
videoLibrary.categories.data[categoryIndex].title="PERSONALIZED SERUM";
videoLibrary.categories.data[categoryIndex].coverImage="https://cdn.shopify.com/s/files/1/1234/0846/files/pernolize.png?v=1667552082";
videoLibrary.categories.data[categoryIndex].description="Our proprietary algorithm creates an authentically-personalized formula for magniﬁed results.";

//Video 1
videoLibrary.categories.data[categoryIndex]["videos"]=[];
videoLibrary.categories.data[categoryIndex]["videos"][0]={};
videoLibrary.categories.data[categoryIndex]["videos"][0].title="<span>Benefits of a</span><h2>Persinalized Serum</h2>";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoUrl="https://cdn.shopify.com/videos/c/o/v/ead326860d4a47ee88bfdea7f0da583d.mp4";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoPoster="https://cdn.shopify.com/s/files/1/1234/0846/files/MD_FusionLab_01_Thumbnail.png?v=1667552424";
videoLibrary.categories.data[categoryIndex]["videos"][0].products=[];
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/pages/md-fusion-lab-page');

//video 2
videoLibrary.categories.data[categoryIndex]["videos"][1]={};
videoLibrary.categories.data[categoryIndex]["videos"][1].title="<span>Learn How tospan</span><h2>Apply Your Serum</h2>";
videoLibrary.categories.data[categoryIndex]["videos"][1].videoUrl="https://cdn.shopify.com/videos/c/o/v/1e8af40e0c994181b407f7dcd1530143.mp4";
videoLibrary.categories.data[categoryIndex]["videos"][1].videoPoster="https://cdn.shopify.com/s/files/1/1234/0846/files/MD_FusionLab_02_Thumbnail.png?v=1667552424";
videoLibrary.categories.data[categoryIndex]["videos"][1].products=[];
videoLibrary.categories.data[categoryIndex]["videos"][1].products.push('/pages/md-fusion-lab-page');




